// =====================================================
// CATALOG API CLIENT - Fase 1.C
// =====================================================

import { api } from './client';
import type {
  SiteCatalogResponse,
  LinkItemResponse,
  UnlinkItemResponse,
  UnlinkPreviewResponse,
  UpdateSiteConfigRequest,
  CatalogItemType,
} from '../types/catalog';

const BASE_URL = '/catalog-sites';

export const catalogApi = {
  /**
   * Obtener catálogo completo del centro
   */
  getSiteCatalog: async (siteId: string): Promise<SiteCatalogResponse> => {
    return api.get<SiteCatalogResponse>(`${BASE_URL}/${siteId}`);
  },

  /**
   * Vincular elemento al centro
   */
  linkItem: async (
    siteId: string,
    type: CatalogItemType,
    id: string
  ): Promise<LinkItemResponse> => {
    return api.post<LinkItemResponse>(`${BASE_URL}/${siteId}/link`, { type, id });
  },

  /**
   * Desvincular elemento del centro
   */
  unlinkItem: async (
    siteId: string,
    type: CatalogItemType,
    id: string
  ): Promise<UnlinkItemResponse> => {
    const params = new URLSearchParams({ type, id });
    return api.delete<UnlinkItemResponse>(`${BASE_URL}/${siteId}/unlink?${params.toString()}`);
  },

  /**
   * Obtener preview de elementos que se desvincularán en cascada
   */
  getUnlinkPreview: async (
    siteId: string,
    type: CatalogItemType,
    id: string
  ): Promise<UnlinkPreviewResponse> => {
    const params = new URLSearchParams({ type, id });
    return api.get<UnlinkPreviewResponse>(`${BASE_URL}/${siteId}/unlink-preview?${params.toString()}`);
  },

  /**
   * Actualizar configuración del centro
   */
  updateSiteConfig: async (
    siteId: string,
    config: UpdateSiteConfigRequest
  ): Promise<{ success: boolean; message: string }> => {
    return api.patch<{ success: boolean; message: string }>(
      `${BASE_URL}/${siteId}/config`,
      config
    );
  },
};

export default catalogApi;
